import { Group, Button, TextInput, NumberInput, Select, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';

import { useAppSelector, selectCurrencies } from '@/shared';

import type { TRemotePaymentMethodUpdateParams, TRemotePaymentMethod } from '../store/types';

type FormData = Omit<TRemotePaymentMethodUpdateParams, 'data'> & { data: string };

type Props = {
  method: TRemotePaymentMethod;
  onSubmit: (params: TRemotePaymentMethodUpdateParams) => void;
  onClose: () => void;
};

export const RemoteMethodUpdateForm = (props: Props) => {
  const {
    method,
    onSubmit,
    onClose,
  } = props;

  const avalableCurrencies = useAppSelector(selectCurrencies);

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {
      methodId: method.id,
      name: method.name,
      currency: method.currency,
      data: method.data,
      minRefill: method.minRefill,
      maxRefill: method.maxRefill,
    },
    validate: {
      name: (value) => !value ? 'Введите название метода' : null,
      currency: (value) => !value ? 'Выберите валюту' : null,
      data: (value) => !value ? 'Введите данные в формате JSON' : null,
      minRefill: (value) => !value ? 'Введите минимальную сумму пополнения' : null,
      maxRefill: (value) => !value ? 'Введите максимальную сумму пополнения' : null,
    },
  });

  const handleSubmit = (values: FormData) => {
    const params: TRemotePaymentMethodUpdateParams = {
      ...values,
      data: JSON.parse(values.data),
    };
    onSubmit(params);
    onClose();
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <NumberInput
        label="ID метода"
        withAsterisk
        disabled
        key={form.key('methodId')}
        {...form.getInputProps('methodId')}
      />
      <TextInput
        label="Название метода"
        withAsterisk
        key={form.key('name')}
        {...form.getInputProps('name')}
      />
      <Select
        label="Валюта"
        clearable
        withAsterisk
        data={avalableCurrencies.map((currency) => ({ value: currency, label: currency }))}
        key={form.key('currency')}
        {...form.getInputProps('currency')}
      />
      <NumberInput
        label="Минимальная сумма пополнения"
        withAsterisk
        key={form.key('minRefill')}
        {...form.getInputProps('minRefill')}
      />
      <NumberInput
        label="Максимальная сумма пополнения"
        withAsterisk
        key={form.key('maxRefill')}
        {...form.getInputProps('maxRefill')}
      />
      <Textarea
        label="Данные"
        placeholder="JSON format"
        withAsterisk
        autosize
        minRows={2}
        key={form.key('data')}
        {...form.getInputProps('data')}
      />

      <Group justify="flex-start" mt="30">
        <Button onClick={onClose} variant="outline">
          Отмена
        </Button>
        <Button type="submit">
          Сохранить
        </Button>
      </Group>
    </form>
  );
};
